<div class="container-fluid">
	<div class="row ps-3">
		<app-breadcrumb></app-breadcrumb>
	</div>
	<div class="row px-3">
		<div class="col-md-8 col-sm-12">
			<div class="block-02">
				<header class="bl-header p-3 m-0 border-bottom">
					<h2>Project Name will be placed right here</h2>
				</header>
				<div class="bl-body p-3">
					<div class="row">
						<div class="col-md-6">
							<div class="row py-2">
								<div class="col-md-4 fw-bold text-end">
									Status:
								</div>
								<div class="col-md-8">
									<span class="btn rounded-pill btn-primary btn-sm">Active</span>
								</div>
							</div>
							<div class="row py-2">
								<div class="col-md-4 fw-bold text-end">Client:</div>
								<div class="col-md-8">Link to a client page</div>
							</div>
							<div class="row py-2">
								<div class="col-md-4 fw-bold text-end">Start date:</div>
								<div class="col-md-8">12/12/2021</div>
							</div>
							<div class="row py-2">
								<div class="col-md-4 fw-bold text-end">Closing date:</div>
								<div class="col-md-8">02/12/2022</div>
							</div>
						</div>
						<div class="col-md-6"></div>
					</div>
				</div>
				<footer class="bl-footer"></footer>
			</div>
		</div>
	</div>
</div>
